module.exports = __webpack_public_path__ + "img/yandex-logo.5c46a1c4.svg";